import { Chip, styled } from "@material-ui/core"

export default styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.green,
  color: theme.palette.text.turquoise,
  fontWeight: 700,
  height: theme.spacing(2),
}))
